import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const save = (token, u) => {
    localStorage.setItem("br_token", token);
    setUser(u);
  };

  const logout = useCallback(() => {
    localStorage.removeItem("br_token");
    setUser(null);
  }, []);

  useEffect(() => {
    // CRITICAL: if returning from the Google OAuth callback, skip the /me
    // check — AuthCallback exchanges the session_id and sets the session first.
    if (window.location.hash?.includes("session_id=")) {
      setReady(true);
      return;
    }
    const t = localStorage.getItem("br_token");
    if (!t) {
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("br_token"))
      .finally(() => setReady(true));
  }, []);

  const guestTokenIfAny = () => {
    const t = localStorage.getItem("br_token");
    return user?.is_guest && t ? t : undefined;
  };

  const guest = async () => {
    const r = await api.post("/auth/guest");
    save(r.data.access_token, r.data.user);
    return r.data.user;
  };

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password, guest_token: guestTokenIfAny() });
    save(r.data.access_token, r.data.user);
    return r.data.user;
  };

  const register = async (email, password, name) => {
    const r = await api.post("/auth/register", { email, password, name, guest_token: guestTokenIfAny() });
    save(r.data.access_token, r.data.user);
    return r.data.user;
  };

  return (
    <AuthCtx.Provider value={{ user, ready, guest, login, register, logout, setUser, setSession: save }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
